import {ValueObject} from '@s-ui/domain'

export class VehicleDataValueObject extends ValueObject {
  #text
  #type

  constructor({text, type}) {
    super()
    this.#text = text
    this.#type = type
  }

  static create({text, type}) {
    return new VehicleDataValueObject({text, type})
  }

  get value() {
    return {text: this.#text, value: this.#type}
  }

  toJSON() {
    return {text: this.#text, value: this.#type}
  }
}
